export const DATE_OPTIONS = [
  { label: 'All in past 90 days', value: '90' },
  { label: 'Last 30 days', value: '30' },
  { label: 'Last 60 days', value: '60' },
  { label: 'Custom', value: 'custom' },
];

export const JOB_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Archive unused', value: 'archive' },
  { label: 'Merge duplicates', value: 'merge' },
  { label: 'Categorize uncategorized', value: 'categorize' },
  { label: 'Rename', value: 'rename' },
  { label: 'Update account type', value: 'update-type' },
];

export const APPROVED_OPTIONS = [
  { label: 'Anyone', value: 'anyone' },
  { label: 'Vela auto', value: 'vela' },
  { label: 'Claire Kemanzi', value: 'Claire Kemanzi' },
];

export const DEFAULT_DATE = '90';
export const DEFAULT_JOB = 'all';
export const DEFAULT_APPROVED = 'anyone';

export const GRID_TEMPLATE = '140px 1fr 160px 2fr 100px';